import { StaticFooterData } from './types';

export const footerData: StaticFooterData = {
  brands: {
    main: {
      slug: 'naos',
      title:
        'Экобиология — общее понятие всех брендов NAOS.\nКожа и процессы ее жизнедеятельности — источники нашего вдохновения',
      links: {
        about: '',
        catalog: ''
      },
      social: []
    },
    others: [
      {
        slug: 'bioderma',
        title: 'BIODERMA',
        links: {
          about: '/bioderma/brand',
          catalog: '/catalog/bioderma/'
        },
        social: [
          {
            type: 'vk',
            link: 'https://vk.com/biodermarussia',
            title: 'BIODERMA',
            isBlank: true
          }
        ]
      },
      {
        slug: 'esthederm',
        title: 'Institut Esthederm',
        links: {
          about: '/esthederm/brand',
          catalog: '/catalog/institut-esthederm/'
        },
        social: [
          {
            type: 'vk',
            link: 'https://vk.com/esthederm_russia',
            title: 'Institut Esthederm',
            isBlank: true
          },
          {
            type: 'tg',
            link: 'https://t.me/formulaofaesthetic',
            title: 'Institut Esthederm',
            isBlank: true
          }
        ]
      },
      {
        slug: 'etatPur',
        title: 'Etat Pur',
        links: {
          about: '/etat_pur/brand',
          catalog: '/catalog/etat-pur/'
        },
        social: [
          {
            type: 'vk',
            link: 'https://vk.com/etatpur',
            title: 'Etat Pur',
            isBlank: true
          }
        ]
      }
    ]
  },
  podcast: {
    title: 'Подкаст\n«Бьюти завтрак»',
    socials: [
      {
        link: 'https://t.me/beautybreakfast',
        icon: 'telegram',
        isBlank: true
      },
      {
        link: 'https://dzen.ru/id/6197983bb3b4b65a6ec09e10',
        icon: 'dzen',
        isBlank: true
      },
      {
        link: 'https://www.youtube.com/playlist?list=PLM1XXk1pcnmpmtXv80et71Hz_zDEa82MR',
        icon: 'youtube',
        isBlank: true
      }
    ]
  },
  app: {
    title: 'Приложение «NAOS»',
    stores: [
      {
        type: 'googlePlay',
        link: 'https://play.google.com/store/apps/details?id=ru.naos.android&pli=1',
        isBlank: true
      },
      {
        type: 'apple',
        link: 'https://apps.apple.com/ru/app/naos-%D0%BA%D0%BE%D1%81%D0%BC%D0%B5%D1%82%D0%B8%D0%BA%D0%B0-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0-%D0%B8-%D1%82%D0%B5%D0%BB%D0%B0/id1593052556',
        isBlank: true
      }
    ]
  }
};
